import {Component, Inject, OnInit} from '@angular/core';
import {ChannelsService} from 'src/app/services/channels.service';
import {CustomChannelWithFavorites} from "../../model/customChannelWithFavorites";
import {MetricsService} from "../../services/metrics.service";
import {UserService} from "../../services/user.service";
import {AppConfigService} from "../../app-config.service";
import {ListItem} from "../../model/listItem";
import {CategoryList} from "../../model/categoryList";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {ParentCategory} from "../../model/ParentCategory";
import {Subscription} from "rxjs";
import {UserPreference} from "../../model/userPreference";
import {AppsPreferences} from "../../model/appsPreference.";

@Component({
    selector: 'app-channel-list',
    templateUrl: './channel-list.component.html',
    styleUrls: ['./channel-list.component.scss'],
    animations: [
        trigger('openClose', [
            state('open', style({ opacity: 1, height: '100%', padding: '1.5em' })),
            state('closed', style({ opacity: 0, height: 0, padding: 0 })),
            transition('open => closed', [animate('0.1s')]),
            transition('closed => open', [animate('0.1s')])
        ]),
    ],
    standalone: false
})
export class ChannelListComponent implements OnInit {

    public EMPLOYEE_FILTER = "employees";
    public STUDENT_FILTER = "students";
    // public FACULTY_FILTER = "faculty";

    public VIEW_LIST_TYPE = "list";
    public VIEW_CATEGORY_TYPE = "category";

    public channelCategoryList: Array<ParentCategory> = [];
    public viewedList: Array<CategoryList> = [];
    public roleFilter: Array<string> = [];
    public categoryFilter: Array<string> = [];

    public viewType: string = this.VIEW_CATEGORY_TYPE; // category | list

    public excludeCategories = [
        'Icon'
    ];

    public userPreferences: AppsPreferences;

    public subscriptions = new Subscription();

    public get showIneligibleChannels(): Boolean {
        return (this.appConfig.getShowIneligibleChannels());
    }

    public get showChannelEligibility(): Boolean {
        return (this.appConfig.getShowChannelEligibility());
    }

    public get showRoleFilter() {
        return this.appConfig.showChannelListRoleFilter() && this.channelService.userHasVisibilityAccess();
    }

    private window: Window;

    constructor(
        private channelService: ChannelsService,
        private metricsService: MetricsService,
        private userService: UserService,
        private appConfig: AppConfigService,
        @Inject('Window') window: Window
    ) {
        let me = this;
        this.window = window;
        me.channelService.channelsReady$.subscribe({
            next: (resp: any) => {
                me.channelCategoryList = me.channelService.getAllChannelCategories();
                me.collapseAll();
                me.setParentCategoryVisibility();
            }
        });
    }
    ngOnInit(): void {
        let me = this;
        me.channelCategoryList = me.channelService.getAllChannelCategories();
        me.collapseAll();
        me.processPreferences();
        me.setParentCategoryVisibility();
    }

    public ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
        this.savePreferences();
    }

    public get categoryFilteredList() {
        let me = this;
        let filteredList: Array<ParentCategory> = [];
        me.channelCategoryList.forEach((cat: ParentCategory) => {
            if (me.isFilteredParentCategory(cat.category.title)) {
                filteredList.push(cat);
            }
        });
        return filteredList;
    }

    public sendGAClickEvent(title: string) {
        if (title != '') {
            this.metricsService.sendChannelListClick(title);
        }
    }

    public hasRole(role: string) {
        return this.userService.hasRole(role);
    }

    public resetFilters() {
        this.categoryFilter = [];
        this.roleFilter = [];
        // this.viewType = 'category';
        this.setParentCategoryVisibility();
    }

    public toggleRoleFilter(role: string) {
        if (this.roleFilter.includes(role)) {
            this.roleFilter = [];
        } else {
            this.roleFilter = [role];
        }
        this.setParentCategoryVisibility();
    }

    public toggleCategoryFilter(c: string) {
        if (this.categoryFilter.includes(c)) {
            this.categoryFilter.splice(this.categoryFilter.indexOf(c), 1);
        } else {
            this.categoryFilter.push(c);
        }
        // this.setParentCategoryVisibility();
    }

    public NoResults: boolean = false;
    public setParentCategoryVisibility() {
        let me = this;
        setTimeout( () => {
            me.channelCategoryList.forEach((cat: ParentCategory, index) => {
                if (
                    document.getElementById("category_"+cat.category.id) != undefined
                    && me.window.getComputedStyle(document.getElementById("category_"+cat.category.id))['display'] === 'none'
                ) {
                    me.channelCategoryList[index].is_visible = false;
                } else {
                    me.channelCategoryList[index].is_visible = true;
                }
            } );
        }, 500 );
    }

    public isFilteredParentCategory(cat: string) {
        return (this.categoryFilter.length == 0 || this.categoryFilter.indexOf(cat) >= 0);
    }

    public toggleView() {
        switch (this.viewType) {
            case this.VIEW_CATEGORY_TYPE :
                this.viewType = this.VIEW_LIST_TYPE;
                break;
            case this.VIEW_LIST_TYPE :
                this.viewType = this.VIEW_CATEGORY_TYPE;
                this.collapseAll();
                break;
            default:
                this.collapseAll();
                this.viewType = this.VIEW_CATEGORY_TYPE;
        }
    }

    public collapseAll() {
        let me = this;
        if (me.channelCategoryList.length > 0) {
            me.channelCategoryList.forEach((parentCat: ParentCategory) => {
                if (parentCat.subCategories != undefined && parentCat.subCategories.length > 0) {
                    parentCat.subCategories.forEach((subCat: ParentCategory) => {
                        subCat.is_visible = false;
                    });
                }
            });
        }
    }

    public showChannel(channel: ListItem): boolean {
        if (!this.showIneligibleChannels && !this.userHasFullAccess(channel)) {
            return false;
        }
        if (this.roleFilter.length > 0 && this.userHasVisibilityAccess(channel)) {
            if (channel.is_public) return true;
            if (this.isStudentChannel(channel) && this.roleFilter.includes(this.STUDENT_FILTER)) return true;
            if (this.isEmployeeChannel(channel) && this.userHasFullAccess(channel) && this.roleFilter.includes(this.EMPLOYEE_FILTER)) return true;
        }
        if (this.roleFilter.length == 0 && this.userHasFullAccess(channel)) return true;
        return false;
    }

    public showSubCatTitle(subCategory: ParentCategory) {
        let show = false;
        if (subCategory.channels.length > 0) {
            subCategory.channels.forEach((C: ListItem) => {
                if (this.showChannel(C)) show = true;
            });
        }
        return show;
    }

    public userHasFullAccess(channel: ListItem) {
        // return this.channelService.userHasFullAccess( channel );
        return channel.has_access;
    }

    public userHasVisibilityAccess(channel: ListItem) {
        // return this.channelService.userHasVisibilityAccess(  );
        return channel.has_visibility;
    }

    public isStudentChannel(channel: ListItem) {
        // return this.channelService.channelHasStudentRole( channel );
        return channel.is_student_channel;
    }

    public isEmployeeChannel(channel: ListItem) {
        return channel.is_employee_channel;
    }

    public processPreferences() {
        if (this.userService.getAppsPreferences() != undefined) {
            this.userPreferences = this.userService.getAppsPreferences();
            if (this.userPreferences.view == this.VIEW_CATEGORY_TYPE) {
                this.viewType = this.VIEW_CATEGORY_TYPE;
            } else if (this.userPreferences.view == this.VIEW_LIST_TYPE) {
                this.viewType = this.VIEW_LIST_TYPE;
            }
            if (this.userPreferences.categories.length > 0) {
                this.categoryFilter = this.userPreferences.categories;
            }
            if (this.userPreferences.role.includes(this.EMPLOYEE_FILTER) || this.userPreferences.role.includes(this.STUDENT_FILTER)) {
                this.roleFilter = this.userPreferences.role;
            }
        }
    }

    public savePreferences() {
        if (this.userPreferences == undefined) {
            this.userPreferences = {view: "categories", categories: [], role: []};
        }
        this.userPreferences.view = this.viewType;
        this.userPreferences.categories = this.categoryFilter;
        this.userPreferences.role = this.roleFilter;
        this.userService.saveAppsPreferences(this.userPreferences);
    }

    // public sortIntoCategories() {
    //     console.log( "sortIntoCategories()" );
    //     let me = this;
    //     // let newList: any = [];
    //     let categories: Array<string> = [];
    //     let newViewedList: Array<CategoryList> = [];
    //     let channelList = me.channelService.getAllChannels(); //.sort((a:any, b:any) => a.title.localeCompare(b.title)); //me.channelList.sort((a:any, b:any) => a.title.localeCompare(b.title));
    //     channelList.forEach((el: CustomChannelWithFavorites) => {
    //         if (!this.excludeCategories.includes(el.category)) {
    //             if (categories.includes(el.category)) {
    //                 newViewedList.forEach((item: any, index: number) => {
    //                     if (newViewedList[index].title == el.category) {
    //                         let newItem: ListItem = {
    //                             title: el.title,
    //                             description: el.description,
    //                             keywords: el.keywords,
    //                             goname: el.goname,
    //                             is_visible: true,
    //                             is_public: el.is_public,
    //                             included_roles: (el.include_roles == null ? [] : el.include_roles.split(',')),
    //                             excluded_roles: (el.exclude_roles == null ? [] : el.exclude_roles.split(',')),
    //                             has_access: me.channelService.hasChannelAccess(el),
    //                             eligibility: el.eligibility,
    //                             is_student_channel: me.channelService.channelHasStudentRole(el),
    //                             is_employee_channel: me.channelService.channelHasEmployeeRole(el),
    //                             has_visibility: me.channelService.userHasVisibilityAccess()
    //                         }
    //                         newViewedList[index].items.push(newItem);
    //                         // else if ( me.showIneligibleChannels ) newViewedList[index].hidden_items.push( newItem );
    //                     }
    //                 });
    //             } else {
    //                 categories.push(el.category);
    //                 let newItem: ListItem = {
    //                     title: el.title,
    //                     description: el.description,
    //                     keywords: el.keywords,
    //                     goname: el.goname,
    //                     is_visible: true,
    //                     is_public: el.is_public,
    //                     included_roles: (el.include_roles == null ? [] : el.include_roles.split(',')),
    //                     excluded_roles: (el.exclude_roles == null ? [] : el.exclude_roles.split(',')),
    //                     has_access: me.channelService.hasChannelAccess(el),
    //                     eligibility: el.eligibility,
    //                     is_student_channel: me.channelService.channelHasStudentRole(el),
    //                     is_employee_channel: me.channelService.channelHasEmployeeRole(el),
    //                     has_visibility: me.channelService.userHasVisibilityAccess()
    //                 };
    //                 let newList: CategoryList = {
    //                     title: el.category,
    //                     is_visible: true,
    //                     items: [],
    //                     hidden_items: []
    //                 }
    //                 newList.items.push(newItem);
    //                 newViewedList.push(newList);
    //             }
    //         }
    //     });
    //     // newViewedList = newViewedList.sort((a:any, b:any) => a.title.localeCompare(b.title));
    //     return newViewedList;
    // }
    // public isFilteredCategory(cat: string) {
    //     if (this.categoryFilter.length == 0) return true;
    //     let ret = false;
    //     this.channelCategoryList.forEach((parent: ParentCategory) => {
    //         if (parent.subCategories.length > 0) {
    //             parent.subCategories.forEach((sub: ParentCategory) => {
    //                 if (sub.category.title == cat) ret = this.categoryFilter.includes(parent.category.title);
    //             });
    //         }
    //     });
    //     return ret;
    // }


}
